import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import countrySlice, { Country } from "./slice";
import { PayloadAction } from "@reduxjs/toolkit";

type CountryResponse = ApiResponse<{ data: Country[] }>;

function* countrySaga() {
  yield takeLatest(countrySlice.actions.fetchData, handleFetch);
  yield takeLatest(
    countrySlice.actions.fetchDepartureData,
    handleFetchDeparture
  );
  yield takeLatest(countrySlice.actions.fetchArrivalData, handleFetchArrival);
}

function* handleFetch() {
  const response: CountryResponse = yield call(fetchAPI, "/countries");

  if (response && response.data) {
    yield put(countrySlice.actions.setData(response.data));
  }

  yield put(countrySlice.actions.setIsLoading(false));
}

function* handleFetchDeparture() {
  const response: CountryResponse = yield call(
    fetchAPI,
    `/countries?departure_active_routes=1`
  );

  if (response && response.data) {
    yield put(countrySlice.actions.setDepartureData(response.data));
  }

  yield put(countrySlice.actions.setIsLoadingDeparture(false));
}

function* handleFetchArrival({
  payload: departure_country_id,
}: PayloadAction<number>) {
  const response: CountryResponse = yield call(
    fetchAPI,
    `/countries?departure_country_id=${departure_country_id}`
  );

  if (response && response.data) {
    yield put(countrySlice.actions.setArrivalData(response.data));
  }

  yield put(countrySlice.actions.setIsLoadingArrival(false));
}

export default countrySaga;
